import React from "react";
import { Input } from "antd";

const QRManagementSearch = ({ setSearchedValue }) => {
  return (
    <>
      <Input
        className="qr-management-search-input"
        placeholder="Търсене по маса"
        onChange={(e) => setSearchedValue(e.target.value)}
      />
    </>
  );
};

export default QRManagementSearch;
